import { render, staticRenderFns } from "./AccidentReviewIndex.vue?vue&type=template&id=9f699a22&scoped=true&"
import script from "./AccidentReviewIndex.vue?vue&type=script&lang=js&"
export * from "./AccidentReviewIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f699a22",
  null
  
)

export default component.exports